(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball/assets/javascripts/animations/huxflux.js') >= 0) return;  svs.modules.push('/components/tur/ball/assets/javascripts/animations/huxflux.js');

'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.animations = svs.tur.ball.animations || {};
const Events = svs.tur.ball.constants;
class HuxFlux {
  start(ball, toNumber) {
    if (ball && ball.$el) {
      const tl = gsap.timeline({
        onComplete: () => {
          ball.trigger(Events.HUXFLUX_COMPLETED, ball);
        }
      });
      tl.call(() => {
        ball.$el.classList.add('ball-is-huxfluxing');
      });
      tl.fromTo(ball.$number, 0.3, {
        rotation: 0
      }, {
        rotation: 1080,
        scale: 0.4,
        ease: 'none'
      });
      tl.addLabel('skip');
      tl.call(() => {
        ball.setNumber(toNumber);
      });
      tl.to(ball.$number, 1, {
        rotation: 0,
        scale: 1,
        ease: 'elastic.out'
      });
      tl.to(ball.$el, 0.2, {
        scale: 1.2
      }, '-=1');
      tl.to(ball.$el, 0.2, {
        scale: 1
      }, '-=0.8');
      tl.call(() => {
        ball && ball.$el && ball.$el.classList.remove('ball-is-huxfluxing');
      });
      return tl;
    }
  }
}
svs.tur.ball.animations.HuxFlux = new HuxFlux();

 })(window);